export const ADDRESS = '/common/addresses/';
export const CALCULATE = '/references/process/calculate/';
// export const VISUM_IO_URL = 'https://demo.visum.io/filling_page_iframe/';
export const VISUM_IO_URL = 'https://partner1.visum.io/filling_page_iframe';
export const VISUM_IO_SERVICE_URL =
  '/references/visum_io/create_questionnaire/';
